import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=0d559926&scoped=true"
import script from "./Diagnosis.vue?vue&type=script&lang=js"
export * from "./Diagnosis.vue?vue&type=script&lang=js"
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=0d559926&prod&lang=scss&scoped=true"
import style1 from "./Diagnosis.vue?vue&type=style&index=1&id=0d559926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d559926",
  null
  
)

export default component.exports